const sdgwebview = global?.window?.sdgwebview || {};

(() => {
  'use strict';

  sdgwebview.preventPageReload = (() => {
    const urlsToPreventReload = [
      '/account/myaccount/accountQueries.page',
      '/account/register.page',
      '/account/application/creditApplication.page',
      '/account/myaccount/myCredit.page',
    ];

    if (urlsToPreventReload.indexOf(global.window?.location.pathname) > -1) {
      if (typeof sdgwebview.postToNative === 'function') {
        sdgwebview.postToNative('allowReloadPage', false);
      }
    }
  })();
})();

function showCookieBanner() {
  var oneTrustContainer = global.document?.getElementById('onetrust-consent-sdk');
  var banner = global.document.getElementById('onetrust-banner-sdk');

  if (oneTrustContainer === null) {
    return;
  }

  if (banner !== null) {
    banner.style.display = 'none';
  }

  oneTrustContainer.style.display = 'block';
}

function addConsentIdToPreferenceCentre() {
  const observer = new global.MutationObserver((mutations, obs) => {
    var policyText = global.document?.getElementById('ot-pc-desc');

    if (policyText) {
      var consentMessage = '<br><br>Your cookie consent ID: ';

      if (policyText == null) {
        return;
      }

      if (typeof Optanon === 'undefined') {
        return;
      }

      if (policyText.innerHTML.indexOf(consentMessage) > 0) {
        return;
      }

      if (!global.Optanon.getDataSubjectId) {
        return;
      }

      policyText.innerHTML += consentMessage + global.Optanon.getDataSubjectId();
      obs.disconnect();
    }
  });

  observer.observe(global.document, {
    childList: true,
    subtree: true,
  });
}

function cookiePreferenceClick(event) {
  event.preventDefault();

  var appFunctionsAvailable =
    global.window.sdgwebview &&
    global.window.sdgwebview.postToNative &&
    (global.window.sdgwebview.isAndroid || global.window.sdgwebview.isIos);

  if (appFunctionsAvailable) {
    global.window.sdgwebview.postToNative('manageCookiesClicked');
    return;
  }

  if (typeof OneTrust === 'undefined') {
    return;
  }

  addConsentIdToPreferenceCentre();
  showCookieBanner();
  global.OneTrust.ToggleInfoDisplay();
}

global.window.cookiePreferenceClick = cookiePreferenceClick;
